<template>
    <slot />
</template>

<script setup>
    import { hexToHsv } from '#imports';
    import { Color, DoubleSide, Mesh, Vector3 } from 'three';
    import { onBeforeUnmount, ref, watch, watchEffect } from 'vue';

    import { simplePlaneGeometry } from '@resn/gozer-three';
    import { CustomMaterial } from '@resn/gozer-three/materials';
    import { usePane, useRafBool, useThreeObject } from '@resn/gozer-vue';
    import gsap from '@resn/gsap';

    import glslFill from '@/libs/lygia/draw/fill.glsl';
    import glslRect from '@/libs/lygia/draw/rect.glsl';
    import glslRectSDF from '@/libs/lygia/sdf/rectSDF.glsl';
    import { createGradient } from '~/components/gl/shaders/ShaderChunks/create-gradient';

    const props = defineProps({
        layer: {
            type: Number,
            default: 0,
        },
    });

    const active = ref(true);

    const colors = ref(['#090C35', '#25317E', '#C35AFF', '#25317E', '#090C35']);

    const material = new CustomMaterial({
        uniforms: {
            uTime: 0,
            uColors: [],
            uColorCount: colors.value.length,
        },
        fs: /* glsl */ `
            uniform vec3 uColors[5];
            uniform int uColorCount;
            uniform float uTime;

            varying vec2 vUv;

            ${glslRectSDF}
            ${glslRect}
            ${glslFill}
            ${createGradient}

            void main() {
                float gradientT = vUv.y;

                float sceneMask = fill(rectSDF(vUv), 0.9, 0.1);

                vec3 color = createGradient(uColors, uColorCount, gradientT, true);
                
                gl_FragColor = vec4(color, sceneMask);
                // gl_FragColor = vec4(vec3(sceneMask), 1.0);
                
                #include <tonemapping_fragment>
                #include <colorspace_fragment>
            }
        `,
        options: {
            name: 'InfinityBgGradient',
            depthWrite: false,
        },
    });

    watchEffect(() => {
        material.uColors = colors.value.map((c) => {
            // const hsv = hexToHsv(c);
            // const color = new Vector3();
            // color.fromArray(hsv);
            // return color;
            return new Color(c);
        });
    });

    const mesh = new Mesh(simplePlaneGeometry, material);
    mesh.position.z = -0.2;
    mesh.scale.set(2, 1, 1);
    mesh.layers.set(props.layer);
    mesh.renderOrder = -1;

    useThreeObject(mesh, { name: 'InfinityBgGradient' });

    let tl = null;
    const show = ({ delay = 0 } = {}) => {
        tl?.kill();

        const duration = 0.5;

        tl = gsap.timeline({
            delay,
            onStart: () => (active.value = true),
        });
    };

    const hide = ({ delay = 0, swirl = true } = {}) => {
        tl?.kill();

        const duration = 0.5;

        tl = gsap.timeline({
            delay,
            onStart: () => (active.value = true),
            onComplete: () => (active.value = false),
        });
    };

    watchEffect(() => {
        // material.uniforms.uSpinSpeed.value = uSpinSpeed.value;
    });

    useRafBool(active, ({ timestamp }) => {
        // material.uniforms.uTime.value = timestamp * 0.001;
    });

    const destroy = () => {
        material.dispose();
    };

    onBeforeUnmount(destroy);

    defineExpose({ show, hide });

    const paneOptions = {
        min: 0,
        max: 1,
        step: 0.01,
    };

    // const pane = usePane([], { title: 'Infinity Bg' });
    // if (pane) {
    //     pane.addBlade({
    //         view: 'list',
    //         label: 'Color',
    //         options: colors.value.map((c, i) => ({ text: `color ${i}`, value: c })),
    //         value: colors.value[0],
    //     }).on('change', (e) => {
    //         colors.value[0] = e.value;
    //     });
    // }
</script>
